import { render, staticRenderFns } from "./index.html?vue&type=template&id=4d90e2c8&scoped=true&"
import script from "./ProgrammeSubjectImport.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubjectImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d90e2c8",
  null
  
)

export default component.exports